import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserCorrelation } from './marketing-personalisatie.model';

@Injectable({ providedIn: 'root' })
export class MarketingPersonalisatieResource {
    private readonly baseUrl: string = '/services/apix-marketing-personalisatie/api';

    // eslint-disable-next-line @typescript-eslint/naming-convention
    private readonly headers = new HttpHeaders({ Accept: 'application/json', 'X-Api-Key': '{<API_KEY_MARKETING_PERSONALISATIE>}' });

    public constructor(private readonly httpClient: HttpClient) {}

    public getUserCorrelation(): Observable<UserCorrelation> {
        return this.httpClient.get<UserCorrelation>(`${this.baseUrl}/user-correlation`, { headers: this.headers });
    }
}
